import axios from "axios";
import { apiV1Endpoint } from "../../../../../../api/v1";
export const getBeneficiaries = async (ownerId) => {
  try {
    const response = await axios.get(`${apiV1Endpoint}/property/beneficiary?ownerId=${ownerId}`);
    return response?.data?.result?.result?.data;
  } catch (error) {
    console.error("Error fetching owner:", error);
    throw error;
  }
};
